import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { Button, Box } from "@curves/ui-base";
import { CounterBox } from '@icoach/members/components';
import { OrderUncheckoutTable } from './table';
import { useMemberProfileApi } from '@apis/useMemberProfileApi';
import { CheckoutCreditOrderDialog } from '@icoach/memberDetail/dialog';
import { formatCurrencyFn } from '@util/utils';

const MemberDetailOtherContentOrderUncheckout = (props) => {
    const { memberID } = props;
    const { getMemberUncheckoutOrderApi } = useMemberProfileApi();
    const [openDialog, setOpenDialog] = useState(false);
	const [sourceData, setSourceData] = useState({});
	const { orderData = {} } = sourceData;
    const { orders = [], payableTotalPrice = 0, paidTotalPrice = 0 } = orderData;

	const handleRefresh = memberID => {
		doInitOrderCheckoutApi(memberID);
	};

	const handleOpenDialog = () => setOpenDialog(true);

	const handleCloseDialog = () => setOpenDialog(false);

	const doInitOrderCheckoutApi = async memberID => {
		const res = await getMemberUncheckoutOrderApi(memberID);
		if (res) {
			setSourceData(res);
		}
	};

    useEffect(
        () => {
            if (memberID) {
				doInitOrderCheckoutApi(memberID);
            }
        },
        // eslint-disable-next-line
        [memberID],
    );

    return (
        <React.Fragment>
            {payableTotalPrice > 0 && (
                <Grid className={'uncheckout mb-4'} spacing={2} container>
                    <Grid item xs={4}>
                        <CounterBox
                            className={'text-left counter-box-xl'}
                            title="累積欠款"
                            counter={formatCurrencyFn(payableTotalPrice - paidTotalPrice, {
                                symbol: '$',
                            })}
                        />
                    </Grid>
                    <Grid item xs={8}>
						<Box className="btn-group text-right">
							<Button variant="contained" onClick={handleOpenDialog}>
								欠費補款
							</Button>
						</Box>
                    </Grid>
                </Grid>
            )}
            <OrderUncheckoutTable className={'theme-gray'} rowsData={orders} />
			<CheckoutCreditOrderDialog open={openDialog} sourceData={{ memberID }} onClose={handleCloseDialog} refresh={handleRefresh} />
        </React.Fragment>
    );
};

export default MemberDetailOtherContentOrderUncheckout;
